import { ticketClient } from "@/api/index";
import { GetWorkerPerformanceReq, GetAppPerformanceReq } from "@/pbjs/xcommon/ticket_pb";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData } from "@/utils";
// lee 绩效接口参数
interface Options {
  UserName: string;
  ItemId: number; // 工单分类
  Userid: number; // 用户id
  pageIndex: number;
  pageSize: number;
  rank: number;
  sort?: number;
  Hour?: number;
  Email?: string;
  UserGroupId?: string; // 角色
  Statssort: number; // 排序
  Statstype: number;
  Timerange: string;
  Loantype?: number;
  AppName?: string;
  employeeID?: string
  IsCompleted?: any
  Starthour?:any
}
export function getWorkPerformanceExcel(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetWorkerPerformanceReq();
      request.setCommonin(setCommon());
      request.setUsername(arg.UserName);
      request.setItemid(arg.ItemId); // 工单分类
      request.setUserid(arg.Userid); // 用户id
      request.setAppname(arg.AppName)
      if (arg.UserGroupId) {
        request.setUsergroupid(Number(arg.UserGroupId)); // 角色
      }
      if (arg.Loantype) {
        request.setLoantype(Number(arg.Loantype)); // 角色
      }
      if (arg.employeeID) {
        request.setEmployeeid(arg.employeeID); // 角色
      }
      request.setStatssort(arg.Statssort); // 排序
      request.setStatstype(arg.Statstype);
      if (arg.Statstype == 1 || arg.Statstype == 3) {
        request.setHour(arg.Hour);
        request.setStarthour(arg.Starthour);
      }
      request.setTimerange(arg.Timerange);
      request.setEmail(arg.Email);
      (arg.IsCompleted || arg.IsCompleted === 0) && request.setIscompleted(arg.IsCompleted);
      request.setPagein(
        setPage(arg.pageIndex, arg.pageSize, arg.sort, arg.rank)
      );
      // setRank
      let _res = await ticketClient.getWorkerPerformanceExcel(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            // const res: any = response.toObject();
            resolve(response);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
// function getWorkerPerformance(arg: Options) {
//     let _res = getWorkerPerformanceApi(arg);
//     return _res;
// }


export function getAppPerformanceExcel(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetAppPerformanceReq();
      request.setCommonin(setCommon());
      // request.setUsername(arg.UserName);
      request.setItemid(arg.ItemId); // 工单分类
      // request.setUserid(arg.Userid); // 用户id
      request.setAppname(arg.AppName)
      if (arg.UserGroupId) {
        request.setUsergroupid(Number(arg.UserGroupId)); // 角色
      }
      if (arg.Loantype) {
        request.setLoantype(Number(arg.Loantype)); // 角色
      }
      if (arg.employeeID) {
        request.setEmployeeid(arg.employeeID); // 角色
      }
      request.setStatssort(arg.Statssort); // 排序
      request.setStatstype(arg.Statstype);
      if (arg.Statstype == 1 || arg.Statstype == 3) {
        request.setEndhour(arg.Hour);
        request.setStarthour(arg.Starthour);
      }
      request.setTimerange(arg.Timerange);
      // request.setEmail(arg.Email);
      (arg.IsCompleted || arg.IsCompleted === 0) && request.setIscompleted(arg.IsCompleted);
      request.setPagein(
        setPage(arg.pageIndex, arg.pageSize, arg.sort, arg.rank)
      );
      // setRank
      let _res = await ticketClient.getAppPerformanceExcel(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            // const res: any = response.toObject();
            resolve(response);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}